export const API_BASE_URL = "https://api.catchclicker.com";
